import { cn } from '@sparklayer-io/spark-dash-ui/lib/styles';
import { Heading, Pressable, Text } from '@ui/themed';
import { t } from 'i18next';
import type { I18nPrefix } from '../../../i18n/prefix';
import type { FeatureCategory, FeatureCategoryId } from '../constants/features-catalog';

const BASE = 'features:explore.pages.features_page.categories' satisfies I18nPrefix;

/**
 * A row of selectable category cards (Basics / Advanced / Extras)
 */
export function FeatureCategoryCards({
  categories,
  selectedId,
  onSelect,
}: {
  categories: readonly FeatureCategory[];
  selectedId: FeatureCategoryId;
  onSelect: (id: FeatureCategoryId) => void;
}) {
  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
      {categories.map((category) => {
        const isSelected = category.id === selectedId;
        return (
          <Pressable
            key={category.id}
            type="card"
            fullWidth
            fullHeight
            ariaLabel={t(`${BASE}.${category.id}.name`)}
            onClick={() => onSelect(category.id)}
          >
            <div
              className={cn(
                'flex h-full flex-col gap-2 rounded-xl border p-4 text-start transition-colors',
                isSelected
                  ? 'border-platform-primary bg-platform-primary/5'
                  : 'border-gray-200 bg-white hover:bg-gray-50',
              )}
            >
              <Heading level="span" style="md">
                {t(`${BASE}.${category.id}.name`)}
              </Heading>
              <Text variant="secondary">{t(`${BASE}.${category.id}.description`)}</Text>
            </div>
          </Pressable>
        );
      })}
    </div>
  );
}
